export default __webpack_public_path__ + "static/media/desert.52d11dab.png";